import React, { useContext } from 'react';
import SubCategoryTable from './SubCategoryTable';
import { CommonContext } from '../../context/CommonContext';
import { SubCategoryContext } from '../../context/SubCategoryContext';
import { Box, Button, CardHeader, Paper } from '@mui/material';
import AlertMessage from '../common/AlertMessage';
import Loader from '../common/Loader';
import AddModal from './AddModal';
import FilterBar from './FilterBar';
import { Add, DownloadOutlined, UploadOutlined } from '@mui/icons-material';
import UploadSubCategoryModal from './UploadSubCategoryModal';

export default function SubCategoryScreenView() {
    const { openAlert } = useContext(CommonContext);
    const { isLoading, handleAddModal, onExport, handleUploadModal } = useContext(SubCategoryContext);
    return (
        <div className='main-screen'>
            {openAlert && <AlertMessage />}
            {isLoading && <Loader />}
            <AddModal />
            <UploadSubCategoryModal />
            <Box className="component-header">
                <CardHeader title="Sub Category" />
                <Box className="action-btns-group">
                    <Button variant="outlined" className="action-btn" endIcon={<DownloadOutlined />}
                        onClick={() => onExport()}
                    >
                        Export Sub Category[s]
                    </Button>
                    <Button variant="outlined" className="action-btn" endIcon={<UploadOutlined />}
                        onClick={handleUploadModal}
                    >
                        Upload Sub Category
                    </Button>
                    <Button variant="outlined" className="action-btn" endIcon={<Add />} onClick={handleAddModal}>
                        Add Sub Category
                    </Button>
                </Box>
            </Box>
            <Paper sx={{ boxShadow: 'none' }}>
                <FilterBar />
                <SubCategoryTable />
            </Paper>
        </div>
    );
}
